import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { Text } from '../../../src/Components/Themed';
import type { MarketProps, TradeProps } from '../../../src/types';
import { useColors } from '../../../src/constants/useColors';
import { MarketComponentHelpers } from '../../../src/MarketComponents/api';

type TradeTextProps = {
    trade:TradeProps,
    width:number,
    market:MarketProps,
    animate:boolean
}

const TradeText = ({ trade, width, market, animate }:TradeTextProps) => {
    const Colors = useColors();
    const [ local_trade, setLocalTrade ] = useState(trade);
    const [ trade_style, setTradeStyle ] = useState({
        color:Colors.text.h1,
        theme: 'h2',
        borderColor:'transparent',

    });

    useEffect(() => {
        createEffect(trade);
    },[trade]);

    const createEffect = (new_trade:TradeProps) => {
        if(!animate){ return }
        setTradeStyle({ color: Colors.text.action, theme:'h1', borderColor:Colors.text.action })
        setTimeout(() => {
            setTradeStyle({ color: Colors.text.h1, theme:'h2', borderColor:'transparent' })
        }, (500));
        setTimeout(() => {
            setTradeStyle({ color: Colors.text.action, theme:'h1', borderColor:Colors.text.action })
        }, 1000);
        setTimeout(() => {
            setTradeStyle({ color: Colors.text.h1, theme:'h2', borderColor:'transparent' });
            setLocalTrade(new_trade)
        }, (1500));
    }

    return (
        <View key={trade.trade_id.toString()} style={{ width, padding:5, borderWidth:1, borderColor:trade_style.borderColor, borderRadius:4 }}>
            {market.var_1_required ?
            <Text theme={trade_style.theme as any} textAlign='center' color={trade_style.color}>{MarketComponentHelpers.getVar1Label(market, local_trade.var_1)}</Text>
            :
            <Text theme={trade_style.theme as any} textAlign='center' color={trade_style.color}>{MarketComponentHelpers.getOddsLabel(local_trade.odds)}</Text>
            }
        </View>
    )
}

export default TradeText